"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./HeadshotDumpling.scss");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _HeadshotDumplingMethods = require("./HeadshotDumplingMethods");
var _checkForRenderAnchorTag = require("../../utils/methods/checkForRenderAnchorTag");
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const HeadshotDumpling = _ref => {
  let {
    content = {},
    filter
  } = _ref;
  const {
    image,
    header,
    subHeader,
    text,
    link = {},
    color,
    Link,
    GatsbyImage
  } = content;
  const {
    mouse
  } = (0, _useMouse.default)();
  const linkLess = (0, _HeadshotDumplingMethods.checkIfLinkIsEmptyObject)(link);
  const componentJSX = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !linkLess && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    className: mouse ? "ter-headshot-dumpling__link-wrapper" : "ter-headshot-dumpling__link-wrapper tagFocus",
    to: link?.url,
    Link: Link && Link,
    style: {
      color: color || "#000000"
    }
  }, (0, _HeadshotDumplingMethods.renderHeadshotDumpling)(mouse, image, header, subHeader, text, link, filter, color)), linkLess && !link.url && (0, _HeadshotDumplingMethods.renderHeadshotDumpling)(mouse, image, header, subHeader, text, link, filter, color));
  return componentJSX;
};
var _default = HeadshotDumpling;
exports.default = _default;
HeadshotDumpling.propTypes = {
  content: _propTypes.default.shape({
    image: _propTypes.default.shape({
      url: _propTypes.default.string,
      altText: _propTypes.default.string
    }),
    header: _propTypes.default.string.isRequired,
    subHeader: _propTypes.default.string,
    text: _propTypes.default.string.isRequired
  }),
  filter: _propTypes.default.string
};